// libs
import styled, { css } from 'styled-components'
// constants
import { SIDEBAR_NAVIGATION_WIDTH } from 'constants/layout'
// theme
import { colors } from 'themes'
// utils
import { size } from 'polished'
import { isUndefined } from 'lodash/fp'

export const sidebarIconCSS = css<{ isActive?: boolean }>`
  ${size('24px')};

  fill: ${colors.gray900};

  &:hover {
    ${({ isActive }) => !isActive && `fill: ${colors.purple300};`};
  }
`

export const SearchWrapper = styled.div`
  position: relative;
  border-radius: 3px;
  height: 40px;
  width: 460px;
  margin-right: 20px;
  background-color: ${colors.white100};
  color: ${colors.gray900};
`

export const SearchIconWrapper = styled.div`
  height: 100%;
  position: absolute;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 10px;
`

export const FilterIconWrapper = styled.div`
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 10px;
`

export const LayoutContainerInnerWrapper = styled.div<{
  offset?: number
  isPlan?: boolean
  $isReview?: boolean
}>`
  padding: ${({ isPlan }) => (isPlan ? 0 : 20)}px;
  padding-left: ${({ offset }) => (isUndefined(offset) ? `calc(${SIDEBAR_NAVIGATION_WIDTH}px + 20px)` : `${offset}px`)};
  transition: 0.2s padding-left ease-in-out;
  width: 100%;
  height: 100%;

  ${({ $isReview }) =>
    $isReview &&
    css`
      height: 100%;
      padding: 0 0 0 16px;
    `}
`
